"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));
var _shared = _interopRequireDefault(require("./shared"));
/**
 * Light wrapper around the shared apollo-client implementation
 */
var _default = (options = {}) => {
  if (options.cache) {
    throw Error('Passing in a pre-generated cache on the server will cause data to be shared ' + 'across requests and will make you have a Bad Time. Please use the `createCache` option instead. ' + 'See https://github.com/NerdWallet/nwjs-apollo#customizing-apollo-client for more info.');
  }
  const acOptions = {
    ...options,
    log: msg => _appConfig.default.DEBUG && (0, _get2.default)(options, 'options.serverRequest.log.warn') && options.serverRequest.log.warn(msg),
    ssrMode: true
  };
  if (options.createCache) {
    acOptions.cache = options.createCache();
    delete acOptions.createCache;
  }
  return (0, _shared.default)(acOptions);
};
exports.default = _default;